// src/theme/typography.js
const typography = {
  fontFamily: '"Poppins", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  h1: {
    fontWeight: 700,
    fontSize: '1.6rem',   // was 2rem
    lineHeight: 1.2,
  },
  h2: {
    fontWeight: 700,
    fontSize: '1.4rem',   // was 1.75rem
    lineHeight: 1.3,
  },
  h3: {
    fontWeight: 600,
    fontSize: '1.2rem',   // was 1.5rem
    lineHeight: 1.3,
  },
  h4: {
    fontWeight: 600,
    fontSize: '1rem',     // was 1.25rem
    lineHeight: 1.4,
  },
  h5: {
    fontWeight: 600,
    fontSize: '0.9rem',   // was 1.125rem
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: 600,
    fontSize: '0.7rem',   // was 0.875rem
    lineHeight: 1.5,
  },
  body1: {
    fontSize: '0.7rem',   // was 0.875rem
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.6rem',   // was 0.75rem
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: '0.8rem',   // was 1rem
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: '0.6rem',   // was 0.75rem
    fontWeight: 500,
    lineHeight: 1.5,
  },
  button: {
    fontSize: '0.6rem',   // was 0.75rem
    fontWeight: 600,
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.5rem',   // was 0.625rem
    lineHeight: 1.5,
  },
  overline: {
    fontSize: '0.5rem',   // was 0.625rem
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
};

export default typography;
